import { render, staticRenderFns } from "./ServeFeeList.vue?vue&type=template&id=342458bd"
import script from "./ServeFeeList.vue?vue&type=script&lang=js"
export * from "./ServeFeeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports